import React from "react"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { type Customer } from "@/api/graphql"
import ClientData from "@/common/client_data"
import FormCheckbox from "@/common/components/form_checkbox"
import Util from "@/common/util"

interface NewsletterCheckboxProps {
  customer?: Pick<Customer, "business" | "newsletterEnabled" | "marketingConsents"> | null
}

const NewsletterCheckbox: React.FC<NewsletterCheckboxProps> = ({ customer }) => {
  const { t } = useTranslation()
  const { watch } = useFormContext()
  const company = watch("company")
  const clientRole = watch("clientRole")
  const disabledByClientRole = clientRole === null

  let newsletterLabel: string | React.ReactNode = (
    <div dangerouslySetInnerHTML={{ __html: ClientData.snippet("consent") }} />
  )

  if (
    (customer && customer.business) ||
    (customer?.newsletterEnabled && !customer.marketingConsents) ||
    !Util.isBlank(company)
  ) {
    newsletterLabel = t("order.enable_newsletter")
  }

  return (
    <div id="newsletter_enabled_field" className="checkbox text">
      <span className="paragraph-xs bold">{t("order.subscribe_newsletter")}</span>
      <FormCheckbox
        name="newsletterEnabled"
        id="newsletter_enabled"
        label={newsletterLabel}
        disabled={disabledByClientRole}
      />
    </div>
  )
}

export default NewsletterCheckbox
